import axios from 'axios'

class NegotiationCntractService {
    constructor(apiUrl){
        this.apiUrl = apiUrl
    }

    /**
    * @author Edgar Escobedo
    * @description Create workflow and inbox to negotiate contract process
    * @updatedDate 08-02-2023
    * @param {String} contractId
    * @returns {Object}
    * @memberof NegotiationCntractService
    */
   async createWorkflowInboxNegotiation(contractId, token){
    let response = await axios.post(`${this.apiUrl}/negotiation-request`,
    {
        contractId    
    },
    {
        headers:{
            'Authorization' : `Bearer ${token}`
        }
    })
    return response.data
   }

    /**
    * @author Edgar Escobedo
    * @description GET all info to wiev consult negotiation
    * @updatedDate 14-05-24
    * @param {String} workflowExecutionId
    * @returns {Object}
    * @memberof NegotiationCntractService
    */
    async getTeamNegotiationAndContract(workflowExecutionId, token){
        let response = await axios.get(
            `${this.apiUrl}/members-assigned-to-workflow-execution?workflowExecutionId=${workflowExecutionId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          return response.data;
    }
}

export {NegotiationCntractService as default}